import { defineComponent as _defineComponent } from 'vue'
import MainHeader from "@/components/base/MainHeader.vue";
import MainFooter from "@/components/base/MainFooter.vue";
import HelpSingleArticle from "@/components/help/HelpSingleArticle.vue";
import HelpNavigationArticle from "@/components/help/HelpNavigationArticle.vue";
import HelpRelatedArticle from "@/components/help/HelpRelatedArticle.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'HelpSingleView',
  setup(__props) {

const article = {
  title: {
    head: "How to Price Your Products in 7 Easy Steps + What to Consider",
    description:
      "You don't want to price your product too high and drive away customers, but you also don't want to price it too low and miss out on profits.",
    image: "/src/assets/img/help_article.jpg",
  },
  author: {
    name: "Marina Yalanska",
    update: "Updated 2 months ago",
    image: "/src/assets/img/help_author.jpg",
  },
  content: `
    <h2>Summary of the Best Gumroad Alternatives</h2>
    <p>
      Digital sales require no shipping, storage and very little overhead.
      In fact, once a creator makes an asset, the rest is almost completely
      passive income.
    </p>
    <p>
      Gumroad is an online platform that allows creators to sell their
      digital products directly to their audience. Founded in 2011 by Sahil
      Lavingia, Gumroad has become the go-to platform for creative
      entrepreneurs to sell their digital products.
    </p>
    <p>
      However, a 2022 change in Gumroad's pricing proved to be a massive
      gut-punch to creators. As a result, many are scrambling for an
      alternative to selling digital goods.
    </p>
    <p>
      In this post, you'll learn about the best Gumroad alternatives and the
      unique features of each platform. Whether you're looking to switch
      platforms or looking for a new place to sell digital or physical
      products, this post will give you a clearer picture of your next
      steps. With that said, let's jump right in.
    </p>
    <br />
    <br />
    <p>
      Digital sales require no shipping, storage and very little overhead.
      In fact, once a creator makes an asset, the rest is almost completely
      passive income.
    </p>
    <p>
      Gumroad is an online platform that allows creators to sell their
      digital products directly to their audience. Founded in 2011 by Sahil
      Lavingia, Gumroad has become the go-to platform for creative
      entrepreneurs to sell their digital products.
    </p>
    <p>
      However, a 2022 change in Gumroad's pricing proved to be a massive
      gut-punch to creators. As a result, many are scrambling for an
      alternative to selling digital goods.
    </p>
    <p>
      In this post, you'll learn about the best Gumroad alternatives and the
      unique features of each platform. Whether you're looking to switch
      platforms or looking for a new place to sell digital or physical
      products, this post will give you a clearer picture of your next
      steps. With that said, let's jump right in.
    </p>
  `,
};
const listLinks = [
  {
    link: "/help/1",
    label: "Import your product catalog",
  },
  {
    link: "/help/2",
    label: "Adding feed templates",
  },
  {
    link: "/help/3",
    label: "Setting up your feed",
  },
  {
    link: "/help/4",
    label: "Publish a feed",
  },
];
const popularLinks = [
  {
    id: 1,
    title: "How to Price Your Products in 7 Easy Steps + What to Consider 1",
    imageUrl: "/src/assets/img/help_article.jpg",
    description:
      "You don't want to price your product too high and drive away customers, but you also don't want to price it too low and miss out on profits.",
    category: "Business Planning",
  },
  {
    id: 2,
    title: "How to Price Your Products in 7 Easy Steps + What to Consider 2",
    imageUrl: "/src/assets/img/help_article.jpg",
    description:
      "You don't want to price your product too high and drive away customers, but you also don't want to price it too low and miss out on profits.",
    category: "Business Planning",
  },
  {
    id: 3,
    title: "How to Price Your Products in 7 Easy Steps + What to Consider 3",
    imageUrl: "/src/assets/img/help_article.jpg",
    description:
      "You don't want to price your product too high and drive away customers, but you also don't want to price it too low and miss out on profits.",
    category: "Business Planning",
  },
  {
    id: 4,
    title: "How to Price Your Products in 7 Easy Steps + What to Consider 4",
    imageUrl: "/src/assets/img/help_article.jpg",
    description:
      "You don't want to price your product too high and drive away customers, but you also don't want to price it too low and miss out on profits.",
    category: "Business Planning",
  },
];

return { __sfc: true,article, listLinks, popularLinks, MainHeader, MainFooter, HelpSingleArticle, HelpNavigationArticle, HelpRelatedArticle }
}

})